import { useEffect, useState } from 'react'
import BtnClose from './shared/BtnClose';
import { SliderMultiplier } from './SliderMultiplier';

interface propsTypes{
  listImgLink:string[]
}

const Screenshot: React.FC<propsTypes> = (props) => {
  const{ listImgLink } = props;
  const [isOpen, setIsOpen] = useState(false);

  useEffect(()=>{
    if(listImgLink.length !== 0 )
      setIsOpen(true)
      
  },[listImgLink])

  const handleClose = () => {
    setIsOpen(false);
  }

  const blockScreenShot = () => {
    return(
      <div className="block-screenshots">
        {
          <SliderMultiplier listImg={listImgLink}/>
        }
      </div>
    );
  }

  return (
      <div className={`full-screenshots ${isOpen ? "show" : ""}`}>
        <BtnClose close={() => handleClose()}/>
        {blockScreenShot()}
      </div>
  )
}

export default Screenshot
